import { IActivityCreate, IActivityDetails, IActivityListSearch, IEditActivityPayload, IGetActivityList } from "../../../types/sales/activityInterface";
import { EditMyActivityByIdPayload, MyActivityData, MyActivityListData, MyActivityListSearch } from "../../../types/sales/myActivityInterface";
import { ActivityActionTypes, ActivityActions } from "../../actionTypes/sales/activityActionTypes";


export const createActivity = (payload: IActivityCreate): ActivityActionTypes => ({
  type: ActivityActions.CREATE_ACTIVITY,
  payload,
});

export const getActivityList = (payload: IActivityListSearch): ActivityActionTypes => ({
  type: ActivityActions.GET_ACTIVITY_LIST,
  payload,
});

export const setActivityList = (activityList: Array<IGetActivityList>) : ActivityActionTypes => ({
  type: ActivityActions.SET_ACTIVITY_LIST,
  payload: activityList
})

export const setActivityListPageCount = (payload:number): ActivityActionTypes => ({
  type: ActivityActions.SET_ACTIVITY_LIST_PAGE_COUNT,
  payload
})

export const getActivityDataById = (id: number | string): ActivityActionTypes => ({
  type: ActivityActions.GET_ACTIVITY_DATA_BY_ID,
  payload: id
})

export const setActivityDataById = (payload: IActivityDetails) => ({
  type: ActivityActions.SET_ACTIVITY_DATA_BY_ID,
  payload
})

export const editActivity = (payload: IEditActivityPayload) => ({
  type: ActivityActions.EDIT_ACTIVITY_DATA_BY_ID,
  payload,
});

export const getMyActivityList = (payload: MyActivityListSearch): ActivityActionTypes => ({
  type: ActivityActions.GET_MY_ACTIVITY_LIST,
  payload,
});

export const setMyActivityList = (activityList: Array<MyActivityListData>) : ActivityActionTypes => ({
  type: ActivityActions.SET_MY_ACTIVITY_LIST,
  payload: activityList
})

export const setMyActivityListPageCount = (payload: number): ActivityActionTypes => ({
  type: ActivityActions.SET_MY_ACTIVITY_LIST_PAGE_COUNT,
  payload
})

export const getMyActivityDataById = (id: string): ActivityActionTypes => ({
  type: ActivityActions.GET_MY_ACTIVITY_BY_ID,
  payload: id
})

export const setMyActivityData = (payload: MyActivityData) => ({
  type: ActivityActions.SET_MY_ACTIVITY_DATA,
  payload
})

export const editMyActivityById = (payload: EditMyActivityByIdPayload) => ({
  type: ActivityActions.EDIT_MY_ACTIVITY_BY_ID,
  payload,
});